export default __webpack_public_path__ + "static/media/jincheng.72063b9d.png";